export const formatLedgerAmount = (amount: string, currency: string) => {
  const trimmed = amount.trim();
  if (!/^-?\d+$/.test(trimmed)) {
    return currency ? `${currency} ${amount}` : amount;
  }

  const negative = trimmed.startsWith("-");
  const cents = BigInt(negative ? trimmed.slice(1) : trimmed);
  const hundred = BigInt(100);
  const whole = (cents / hundred).toString();
  const fraction = (cents % hundred).toString().padStart(2, "0");
  const sign = negative && cents !== BigInt(0) ? "-" : "";
  const quantity = `${sign}${whole}.${fraction}`;
  return currency ? `${currency} ${quantity}` : quantity;
};
